export default __webpack_public_path__ + "static/icon-bike-f3a5465a9dfdb1914d03bb1aecb6f5d9.svg";